export default __webpack_public_path__ + "static/media/externalLinkWhite.cbe1733c.svg";